export default function stringify(value) {
  return JSON.stringify(value);
}
